import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmailUtilsService {

  constructor() { }

  getEmailIds(input: string | string[]): string[] {
    // Convert input to string if it's an array
    const inputString = Array.isArray(input) ? input.join(' ') : input;
    
    if (!inputString || typeof inputString !== 'string') {
      return Array.isArray(input) ? input : [];
    }

    // Email validation regex pattern
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    // Regex to find emails in angle brackets (RFC 2822 format)
    const angleBracketEmailRegex = /<([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})>/g;
    
    // Regex to find standalone email addresses
    const standaloneEmailRegex = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/g;
    
    const foundEmails: string[] = [];
    
    // First, extract emails from angle brackets (e.g., "Name" <email@domain.com>)
    let match;
    while ((match = angleBracketEmailRegex.exec(inputString)) !== null) {
      foundEmails.push(match[1]);
    }
    
    // Remove angle bracket emails from the string to avoid duplicates
    let remainingString = inputString.replace(angleBracketEmailRegex, '');
    
    // Then find standalone email addresses in the remaining string
    while ((match = standaloneEmailRegex.exec(remainingString)) !== null) {
      const email = match[0];
      // Only add if not already found and passes validation
      if (!foundEmails.includes(email) && emailRegex.test(email)) {
        foundEmails.push(email);
      }
    }
    
    // Return found emails if any, otherwise return original input as array
    return foundEmails.length > 0 ? foundEmails : (Array.isArray(input) ? input : [input]);
  }
}
